import type { FaireProductEntity } from "../../entity_types/product";

export const p_y346nrvmkt: FaireProductEntity = {
  token: "p_y346nrvmkt",
  type: "product",
  name: "Peanuts Snoopy 75th Anniversary Pin Badge Collection",
  brandName: "K-Wonderland",
  imageUrl:
    "https://cdn.faire.com/fastly/5c7b9e8a37656e98ea6fbd00ede1968392ba4097e34e658f6e5806323e5edc6e.jpeg",
  priceDollars: 4.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/9c0c9296b0ac3e9b8de2e72f3645dd5c89ea03d0ad4bbc53dfcf7ec3ff8a6e92.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
